const ValidatorPerson = (
    person,
    checkPassOderPerso = null,
    checkTelefonOderEmail = null
) => {

    if (!person.meta.touched) {
        return {
            valid:true,
            message: [],
        }        
    }
    var msg = []

    if ( !checkAllPropsOk(person) ) {
        msg.push("Bitte korrigieren Sie die rot markierten Felder")
    }

    if (checkPassOderPerso) {
        msg = [...msg, ...checkPassOderPersoAngegeben(person)]
    }

    if (checkTelefonOderEmail) {
        msg = [...msg, ...checkTelefonOderEmailAngegeben(person)]    
    }

    return {
        valid:(msg.length < 1),
        message: msg,
    }

}

const checkAllPropsOk = (person) => {
    for (let item in person) {
        if (person[item].valid === false) {
            return false;
        }
    }
    return true;
}

const checkPassOderPersoAngegeben = (person) => {

    if ( !person.personalausweisnummer.display) {
        return [];
    }

    if ( !person.reisepassnummer.display) {
        return [];
    }

    if ( person.personalausweisnummer.value || person.reisepassnummer.value ) {
        return [];
    }

    return [
        "Bitte geben Sie Ihre Personalausweisnummer oder Ihre Reisepassnummer an."
    ];
}

const checkTelefonOderEmailAngegeben = (person) => {
    if ( person.telefon.value || person.email.value ) {
        return [];
    }

    return [
        "Bitte geben Sie mindestens eine Telefonnumer oder Ihre E-Mail-Adresse an."
    ];
}

export default ValidatorPerson;
